export const ConnectedIcon = ({ connected, ...props }) => (
    <span {...props}>
        <i className={"fa-circle " + (connected ? "fa-solid text-success" : "fa-regular")}></i>
        <span className="sr-only">{connected ? "Online" : "Offline"}</span>
    </span>
)
